import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { FiltersService } from '../../services/filters.service';
import { GridService } from '../../services/grid-defs.service';
import { Country } from '../../models/country.model';
import { IFilterParams } from 'ag-grid-community';

@Component({
  selector: 'app-checkbox-filter',
  templateUrl: './checkbox-filter.component.html',
  styleUrls: ['./checkbox-filter.component.css']
})
export class CheckboxFilterComponent implements OnInit {
  form: FormGroup;
  countries: Country[];
  filter = '';
  disabled = true;
  params: any;
  currentColumn: string;
  selectedFilter;

  filters: {
    certificates: any;
    users: any;
  } = {
    certificates: {},
    users: {}
  };

  constructor(
    private formBuilder: FormBuilder,
    public filtersService: FiltersService,
    public gridService: GridService
  ) {
    this.form = this.formBuilder.group({
      orders: new FormArray([])
    });
  }

  ngOnInit() {}

  private addCheckboxes() {
    this.filters.certificates = this.filtersService.certificatesFilters;
    this.filters.users = this.filtersService.usersFilters;
    this.selectedFilter = this.filters[this.gridService.currentDef][
      this.currentColumn
    ];
    this.selectedFilter.forEach(filter => {
      const control = new FormControl(true);
      (this.form.controls.orders as FormArray).push(control);
    });
  }

  get arrayOfOrders() {
    return (this.form.get('orders') as FormArray).controls;
  }

  agInit(params: IFilterParams): void {
    this.currentColumn = params.colDef.field;
    this.params = params;
    this.addCheckboxes();
  }

  isFilterActive() {
    return this.disabled !== false;
  }

  getValue(value) {
    if (typeof value === 'string') {
      return value;
    } else {
      return value.code;
    }
  }

  doesFilterPass(params) {
    const value = this.getValue(params.data[this.currentColumn]);
    const valueOfControlers = this.form.get('orders').value;
    const checkedFilters = valueOfControlers.map((inputWord, i) => {
      if (inputWord) {
        if (this.currentColumn === 'role') {
          return this.selectedFilter[i].shortName;
        }
        return this.selectedFilter[i].code;
      }
    });
    return checkedFilters.includes(value);
  }

  getModel() {
    return { filter: this.filter };
  }

  setModel(model) {
    this.filter = model ? model.filter : '';
  }

  executeCallback(index: number, params, event) {
    const items = this.form.get('orders') as FormArray;
    const selectedItem = items.value;

    if (this.currentColumn === 'status') {
      const isLast = index === this.filters[this.gridService.currentDef].status.length - 1;
      if (isLast) {
        const elemnt = selectedItem[index];
        if (elemnt) {
          for (let index = 0; index < items.length; index++) {
            items.controls[index].patchValue({ [index]: true });
          }
        } else {
          for (let index = 0; index < items.length - 1; index++) {
            items.controls[index].setValue(false);
          }
        }
      }
    }
    this.params.filterChangedCallback();
  }
}
